import React from 'react'
import { $enum } from 'ts-enum-util'
import { SuccessIcon, AlertFilledIcon, WarningFilledIcon, NotAvailableIcon } from 'transfix-icons'
import { EQUIPMENT } from 'constants/equipment'
import { RATE_TYPE } from './types/shipperAccessorial'

export const statusIcon: { [key: string]: JSX.Element } = {
  confirmed: <SuccessIcon color='info' size='large' data-test='success-success' />,
  pending: (
    <SuccessIcon className='icon-disabled inline' size='large' data-test='success-disabled' />
  ),
  rejected: <AlertFilledIcon color='error' size='large' data-test='alert-error' />,
  suspended: <WarningFilledIcon color='warning' size='large' data-test='warning-warning' />,
  canceled: <NotAvailableIcon color='coolGray5' className='inline' data-test='not-available' />,
}

export const statusToolTips: { [key: string]: string } = {
  confirmed: 'This customer has been validated and successfully onboarded.',
  pending: 'This customer is in the process of being validated and onboarded.',
  rejected: 'Not a valid customer.',
  suspended:
    'This account has been suspended until pending issues (likely overdue payments) are resolved.',
  canceled:
    'This account has been canceled.  Customer is no longer approved to do business with Transfix OR has been moved to another profile.',
}

export const fsmaStatusToolTips = (fsmaState: boolean) =>
  `Transfix has${fsmaState ? '' : ' not'} approved this customer to ship FSMA loads.`

export const generateCohortYears = () => {
  const thisYear = new Date().getFullYear()
  const years = []
  for (let i = 2013; i <= thisYear; i += 1) {
    years.push({
      label: `${i}`,
      value: i,
    })
  }
  return years
}

export const rateTypeLabel = (rateType?: string): string => {
  const label = $enum(RATE_TYPE).getValueOrThrow(rateType)
  if (label === RATE_TYPE.flat_rate) return ''
  return `/${label}`
}

export const getEquipmentName = (id?: number | null) => {
  const equipmentName = EQUIPMENT.find(e => id === e.id)?.name

  if (equipmentName) {
    return `(${equipmentName})`
  }

  return ''
}

export const percentageToFloat = (n: number): number => n / 100

export const floatToPercentage = (n: number): number => Number((n * 100).toFixed(2))
